import { createLinearScale } from '@utils/math.ts'
import TimetoastTemporal from '@base/timetoast_temporal.js'
import TimetoastDateFormatter from '@utils/timetoast_date_formatter.js'
import { exists } from '@utils/functions.js'
import {
  getDaysBetween,
  getStartsOfWeekBetween,
  getMonthsBetween,
  getHalfYearsBetween,
  getYearsBetween,
  getHalfDecadesBetween,
  getDecadesBetween,
  getHalfCenturiesBetween,
  getCenturiesBetween,
  getHalfMilleniaBetween,
  getMilleniaBetween,
  getHalfDecamilleniaBetween,
  getDecamilleniaBetween,
} from '@utils/temporal.js'

function getTickSizeForLabel(string) {
  return string.length > 4 ? 'small' : 'large'
}

export const calculateTicks = function (preferredMagnitude, startTime, endTime, totalDuration, totalWidth) {
  let ticks = []
  if (
    !exists(preferredMagnitude) ||
    !exists(startTime) ||
    !exists(endTime) ||
    !exists(totalDuration) ||
    !exists(totalWidth)
  ) {
    return ticks
  }

  const roundedStartTime = Math.round(startTime)
  const roundedEndTime = Math.round(endTime)

  let startObj = new TimetoastTemporal(roundedStartTime)
  let endObj = new TimetoastTemporal(roundedEndTime)

  let item, items, i, len, time, label
  const scale = createLinearScale([roundedStartTime, roundedEndTime], [0, totalWidth])
  switch (preferredMagnitude) {
    case 'day':
      items = getDaysBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.day(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'week':
      items = getStartsOfWeekBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.day(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'month':
      items = getMonthsBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        if (item.month === 1) {
          label = TimetoastDateFormatter.year(item)
          ticks.push({
            type: 'large',
            label,
            xPos: scale(time),
            key: time,
          })
        } else {
          label = TimetoastDateFormatter.abbreviatedMonth(item)
          ticks.push({
            type: 'small',
            label,
            xPos: scale(time),
            key: time,
          })
        }
      }
      break

    case 'halfyear':
      items = getHalfYearsBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        if (item.month === 1) {
          label = TimetoastDateFormatter.year(item)
          ticks.push({
            type: 'large',
            label,
            xPos: scale(time),
            key: time,
          })
        } else {
          label = null
          ticks.push({
            type: 'small',
            label,
            xPos: scale(item.epochMilliseconds),
            key: time,
          })
        }
      }
      break

    case 'year':
      items = getYearsBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'halfdecade':
      items = getHalfDecadesBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'decade':
      items = getDecadesBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'halfcentury':
      items = getHalfCenturiesBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'century':
      items = getCenturiesBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'halfmillenium':
      items = getHalfMilleniaBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'millenium':
      items = getMilleniaBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'halfdecamillenium':
      items = getHalfDecamilleniaBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    case 'decamillenium':
      items = getDecamilleniaBetween(startObj, endObj)
      len = items.length
      for (i = 0; i < len; i++) {
        item = items[i]
        time = item.epochMilliseconds
        label = TimetoastDateFormatter.year(item)
        ticks.push({
          type: getTickSizeForLabel(label),
          label,
          xPos: scale(time),
          key: time,
        })
      }
      break

    default:
    //console.log("Unsupported time scale magnitude:", preferredMagnitude)
  }
  return ticks
}
